import router from "../../router";
import leadService from "../../services/leadService";

const getDefaultState = () => {
  return {
    uuid: null,
    noSubscribe: null,
    agent: null,
    agentJwt: null,
    agentRef: null,
    agentRefElec: null,
    agentRefGas: null,
    allowBxlResi: false,
    campaign: null,
    promo: null,
    is2Step: 0,
    lang: "fr",
    printLoading: false,
    restrictedPostalCodes: []
  };
};

export default {
  namespaced: true,
  state: getDefaultState(),
  mutations: {
    setUuid(state, value) {
      state.uuid = value;
    },
    setNoSubscribe(state, value) {
      state.noSubscribe = true;
    },
    setAgent(state, value) {
      state.agent = value;
    },
    setAgentJwt(state, value) {
      state.agentJwt = value;
    },
    setAgentRef(state, value) {
      state.agentRef = value;
    },
    setAllowBxlResi(state, value) {
      state.allowBxlResi = value;
    },
    setRestrictedPostalCodes(state, value) {
      state.restrictedPostalCodes = value;
    },
    setAgentRefElec(state, value) {
      state.agentRefElec = value;
    },
    setAgentRefGas(state, value) {
      state.agentRefGas = value;
    },
    setCampaign(state, value) {
      state.campaign = value;
    },
    setPromo(state, value) {
      state.promo = value;
    },
    setLang(state, value) {
      state.lang = value;
    },
    setCustomerRef(state, value) {
      state.customerRef = value;
    },
    setPrintLoading(state, value) {
      state.printLoading = value;
    },
    setIs2Step(state, value) {
      state.is2Step = value;
    },
    reset(state) {
      Object.assign(state, getDefaultState());
    }
  },
  actions: {
    async setUuid(context) {
      if (!context.state.uuid) {
        if (router.currentRoute.query.uuid != undefined) {
          context.commit("setUuid", router.currentRoute.query.uuid);
        } else {
          try {
            let response = await leadService.new();
            context.commit("setUuid", response.uuid);
          } catch (error) {
            throw error;
          }
        }
      }
    },
    async setParams(context, params) {
      if (params.agent) {
        context.commit("setAgent", params.agent);
      }
      if (params.agentRef) {
        context.commit("setAgentRef", params.agentRef);
      }
      if (params.allowBxlResi) {
        context.commit("setAllowBxlResi", params.allowBxlResi);
      }
      if (params.agentRefElec) {
        context.commit("setAgentRefElec", params.agentRef);
      }
      if (params.agentRefGas) {
        context.commit("setAgentRefGas", params.agentRef);
      }
      if (params.campaign) {
        context.commit("setCampaign", params.campaign);
      }
      if (params.promo) {
        context.commit("setPromo", params.promo);
      }
      if (params.is2Step) {
        context.commit("setIs2Step", params.is2Step);
      }
    },
    async resetParams(context) {
      context.commit("setAgent", null);
      context.commit("setAgentRef", null);
      context.commit("setAgentJwt", null);
      context.commit("setAllowBxlResi", false);
      context.commit("setAgentRefElec", null);
      context.commit("setAgentRefGas", null);
      context.commit("setCampaign", null);
      context.commit("setPromo", null);
      context.commit("setIs2Step", 0);
    },
    async save(context) {
      let data = {
        uuid: context.state.uuid
      };

      let query = router.currentRoute.query;
      if (query.agent !== undefined){
        data["agent"] = query.agent;
        data["agentRef"] = query.agent;
      }
      if (query.agent_guid !== undefined) {
        data["agentGuid"] = query.agent_guid;
      }
      if (context.state.agentRef !== undefined){
        data["agent"] = context.state.agentRef;
        data["agentRef"] = context.state.agentRef;
      }
      if (query.agent_ref_elec !== undefined) {
        data["agentRefElec"] = query.agent_ref_elec;
      }
      if (query.agent_ref_gas !== undefined) {
        data["agentRefGas"] = query.agent_ref_gas;
      }
      if (query.campaign !== undefined || context.state.campaign !== undefined) { // IS-7422: get campaign from state if defined before.
        data["campaign"] = query.campaign || context.state.campaign;
      }
      if (query.promo !== undefined) {
        data["promo"] = query.promo;
      }
      if (query.step !== undefined) {
        data["2step"] = 1;
      } else {
        data["2step"] = 0;
      }

      data["language"] = context.state.lang;

      if (Object.keys(data).length > 1) {
        try {
          await leadService.save(data);
        } catch (error) {
          throw error;
        }
      }
    }
  },
  getters: {
    isTestAchat(state) {
      return state.agentRef === 'AG000132';
    },
    allowBXResi(state) {
      return state.allowBxlResi || state.campaign == 'StayFlex24'; // ER-1212 + IS-7422
    },
    restrictedPostalCodes(state) {
      return state.restrictedPostalCodes;
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/common.js